import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUpdateProductUrl } from "./api-url.constants";
import { UpdateProductBodyDTO } from "./dtos";

export const updateProduct = async (
  hubspotId: string,
  body: UpdateProductBodyDTO
): Promise<void> => {
  const result = await typedFetch(getUpdateProductUrl(hubspotId), {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });

  if (!result.ok) {
    throw new Error("Failed to update product");
  }

  // 204 No Content - successful update without response body
};
